import React from "react";
import { Outlet } from "react-router-dom";

import { ReportsNewProvider } from "./ReportsNewProvider";

const ReportsNewLayout: React.FC = () => {
  return (
    <ReportsNewProvider>
      <Outlet />
    </ReportsNewProvider>
  );
};

export default ReportsNewLayout;
